import {
    apiRequest,
    golonganDetail,
    golonganUpdate
} from "../../../../../services/adapters/kepegawaian/golonganService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", golonganDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", golonganUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository